import router from "@/router/index.js";
import axios from "axios";

export const shared = {
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    makeFav(id, db, which) {
      console.log(id);
      var url = "https://jamespaulgee.com/data.php";
      var formdata = {
        action: "markfa",
        tid: db,
        id: id
      };
      this.axios.post(url, formdata, {
        headers: {
          "Content-Type": "text/plain"
        }
      })
      this.forceRef();
      this.getDocs(which, "");
    },
    forceRerender() {
      this.refresh += 1;
    },
    forceRef() {
      this.$router.go(0);
    },
    async getDocs(which) {
      this.projects = [];
      var url = "https://jamespaulgee.com/data.php";
      var formdata = {
        action: which,
        search: this.search,
        fld: this.fld,
        tid: this.tid,
        xfld: this.xfld
      };
      axios
        .post(url, formdata, {
          headers: {
            "Content-Type": "text/plain"
          }
        })
        .then(res => {
          this.projects = res.data;
          this.total = this.projects.length;
          this.nores = this.projects[0].title;
          if (which == ("displayo" || "displayx")) {
            this.totalA = this.projects.length;
            this.totalT = this.projects.filter(
              obj => obj.source.substring(0, 5) == "Tidal"
            ).length;
            this.totalT2 = this.projects.filter(
              obj => obj.source == "Tidal Album"
            ).length;
            this.totalQ = this.projects.filter(
              obj => obj.source.substring(0, 5) == "Qobuz"
            ).length;
            this.totalQ2 = this.projects.filter(
              obj => obj.source == "Qobuz Album"
            ).length;
          }
        })
        .catch(error => alert(error));
    },
    sendOff(where) {
      router.push(where);
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    sortBy(which) {
      if (which == "dateasc") {
        this.projects.sort((a, b) => (a.title < b.title ? -1 : 1));
        this.projects.sort(function (a, b) {
          var dateA = new Date(a.date),
            dateB = new Date(b.date);
          return dateB - dateA;
        });
      }
      if (which == "datedesc") {
        this.projects.sort((a, b) => (a.title < b.title ? -1 : 1));
        this.projects.sort(function (a, b) {
          var dateA = new Date(a.date),
            dateB = new Date(b.date);
          return dateA - dateB;
        });
      }
      if (which == "title") {
        this.projects.sort((a, b) => (a.title < b.title ? -1 : 1));
      }
      if (which == "source") {
        this.projects.sort((a, b) => (a.source < b.source ? -1 : 1));
      }
      if (which == "pdf") {
        this.projects.sort((a, b) => (a.pdf < b.pdf ? -1 : 1));
      }
      if (which == "codes") {
        this.projects.sort((a, b) => (a.codes < b.codes ? -1 : 1));
      }
      if (which == "rating") {
        this.projects.sort((a, b) => (a.rating > b.rating ? -1 : 1));
      }
      if (which == "topic") {
        this.projects.sort((a, b) => (a.topic < b.topic ? -1 : 1));
      }
      if (which == "date") {
        this.projects.sort((a, b) => (a.date < b.date ? 1 : -1));
      }
      if (which == "plays") {
        this.projects.sort((a, b) => b.plays - a.plays);
      }
      if (which == "tracks") {
        this.projects.sort((a, b) => b.tracks - a.tracks);
      }
      if (which == "ratings") {
        this.projects.sort((a, b) => b.rating - a.rating);
      }
      if (which == "favorites") {
        this.projects.sort(
          (a, b) => a.title - b.title || b.favorite.localeCompare(a.favorite)
        );
      }
    },
    sortByD(which) {
      if (which == "dateasc") {
        this.projects.sort((a, b) => (a.title < b.title ? -1 : 1));
        this.projects.sort(function (a, b) {
          var dateA = new Date(a.date),
            dateB = new Date(b.date);
          return dateB - dateA;
        });
      }
      if (which == "datedesc") {
        this.projects.sort((a, b) => (a.title < b.title ? -1 : 1));
        this.projects.sort(function (a, b) {
          var dateA = new Date(a.date),
            dateB = new Date(b.date);
          return dateA - dateB;
        });
      }
      if (which == "title") {
        this.projects.sort((a, b) => (a.title > b.title ? -1 : 1));
      }
      if (which == "source") {
        this.projects.sort((a, b) => (a.source > b.source ? -1 : 1));
      }
      if (which == "pdf") {
        this.projects.sort((a, b) => (a.pef > b.pef ? -1 : 1));
      }
      if (which == "codes") {
        this.projects.sort((a, b) => (a.codes > b.codes ? -1 : 1));
      }
      if (which == "topic") {
        this.projects.sort((a, b) => (a.topic > b.topic ? -1 : 1));
      }
      if (which == "rating") {
        this.projects.sort((a, b) => (a.rating < b.rating ? -1 : 1));
      }
      if (which == "date") {
        this.projects.sort((a, b) => (a.date > b.date ? 1 : -1));
      }
      if (which == "plays") {
        this.projects.sort((a, b) => a.plays - b.plays);
      }
      if (which == "tracks") {
        this.projects.sort((a, b) => a.tracks - b.tracks);
      }
      if (which == "favorites") {
        this.projects.sort(
          (a, b) => a.title - b.title || b.favorite.localeCompare(a.favorite)
        );
      }
    }
  }
};
